// extracted by mini-css-extract-plugin
export default {"zoomModal":"n5-z","image":"o5-z","button":"p5-z","isOverlayShown":"q5-z"};